import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { SharedArgs } from "../schemas";

const getTherapistActivePatientsQueryKey = (args: SharedArgs) => ["getTherapistActivePatients", args.params] as const;

export const useGetTherapistActivePatients = (args: SharedArgs) => {
  const client = useApiClient();

  return useQuery(getTherapistActivePatientsQueryKey(args), () => client.getTherapistActivePatients(args));
};
